import { useMutation, type UseMutationOptions } from '@zg-rentals/react-query5';
import { BASE_URL } from '../../constants/urls';
import type { ApiResponseDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface CreateCappsUserRequest {
  email: string;
}

async function createCappsUserData(data: CreateCappsUserRequest): Promise<ApiResponseDto<unknown>> {
  const response = await fetch(`${BASE_URL}/rental-manager-api/api/v1/users/capps/createCappsUser`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`Failed to create CAPPS user: ${response.statusText}`);
  }

  return await response.json();
}

export function useCreateCappsUser(
  options?: UseMutationOptions<ApiResponseDto<unknown>, Error, CreateCappsUserRequest, unknown>,
) {
  return useMutation({
    ...options,
    mutationFn: createCappsUserData,
  });
}
